module.exports = __webpack_public_path__ + "img/banner-b3@1x.cc9fab60.jpg";